<template>
  <div>
    <div class="chatContainer" v-if="!chatting">
      <button
        class="chatButton tw-bg-highlight-background-weak tw-text-text"
        type="button"
        @click="chat"
        :disabled="loading"
      >
        <div v-if="loading" class="d-flex align-items-stretch">
          <LoadingState class="me-2" classes="tw-text-highlight-border" />
          <div class="my-auto">Loading...</div>
        </div>
        <template v-else>
          <div><span class="green-dot tw-bg-success-icon"></span>Chat with a human</div>
        </template>
      </button>
    </div>
    <ChatInvite v-if="chatInviteVisible && !isInvitedToChat" @close="() => showChatInvite(false)" />
  </div>
</template>
<script>
import { chatEyeCatcherMixin, chatEyeCatcherSetup } from "@/utils/chatSetup";
import ChatInvite from "@/components/display/ChatInvite";
import LoadingState from "@/components/display/LoadingState";

export default {
  name: "ChatEyeCatcher",
  components: {
    LoadingState,
    ChatInvite,
  },
  mixins: [chatEyeCatcherMixin],
  setup: chatEyeCatcherSetup,
};
</script>
<style lang="scss" scoped>
.chatContainer {
  align-items: center;
  bottom: 0;
  display: flex;
  flex-direction: column;
  height: 165px;
  justify-content: flex-end;
  pointer-events: none;
  position: fixed;
  right: 2rem;
  width: 214px;
  z-index: 30;
}

.chatContainer * {
  pointer-events: initial;
}

.chatButton {
  padding: 10px 16px;
  width: 214px;
  font-family: Verdana, sans-serif;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  -webpack-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  border: none;
  height: 40px;
  cursor: pointer;
  vertical-align: text-bottom;
}

.green-dot {
  display: inline-block;
  border-radius: 50%;
  height: 10px;
  width: 10px;
  margin-right: 0.5rem;
}
</style>
